import React from 'react';
import type { IssueParent } from '../../../../../model/issue-parent/types';
import type { ScreenSize } from '../../../hooks/common/constants';
import { EpicWrapper } from '../../styled';
import EpicLozengeField from '../epic-lozenge-field';
import ParentField from '../parent-field';
import { getLabelWidthMultiplier, LabelType } from '../utils/responsive-labels';

export type Props = {
	cardId: number;
	cardKey: string;
	isUserAtLeastMember: boolean;
	parents: IssueParent[];
	parentId: number | null;
	currentProjectId: number;
	projectIds: number[];
	canUserEditIssue: boolean;
	shouldRenderRichCard: boolean;
	backlogContainerSize?: ScreenSize;
	isCompactView: boolean;
	isSubtask: boolean;
	isEpic: boolean;
	isCompanyManaged: boolean;
};

export const Parent = ({
	cardId,
	cardKey,
	isUserAtLeastMember,
	parents,
	parentId,
	currentProjectId,
	projectIds,
	canUserEditIssue,
	shouldRenderRichCard,
	backlogContainerSize,
	isCompactView,
	isSubtask,
	isEpic,
	isCompanyManaged,
}: Props) => (
	// Using placeholderWidthMultiplier so that with change in container width the width of placeholder changes
	<EpicWrapper
		widthMultiplier={getLabelWidthMultiplier(LabelType.EPIC, backlogContainerSize)}
		// To avoid any extra space show the placeholder only on cards not linked to any epic and are not subtasks
		showPlaceholder={parentId === null && !isSubtask}
	>
		{isEpic && isCompanyManaged ? (
			<EpicLozengeField issueKey={cardKey} issueId={cardId} isCompactView={isCompactView} />
		) : (
			<ParentField
				issueId={cardId}
				issueKey={cardKey}
				isUserAtLeastMember={isUserAtLeastMember}
				parents={parents}
				parentId={parentId}
				currentProjectId={currentProjectId}
				projectIds={projectIds}
				forceEditable={canUserEditIssue}
				shouldRenderRichCard={shouldRenderRichCard}
				isCompactView={isCompactView}
			/>
		)}
	</EpicWrapper>
);
